/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'building/defense_local_dome': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M16 22c-4.687 0-8.5-3.813-8.5-8.5S11.313 5 16 5s8.5 3.813 8.5 8.5S20.687 22 16 22zm0-16c-4.136 0-7.5 3.364-7.5 7.5S11.864 21 16 21s7.5-3.364 7.5-7.5S20.136 6 16 6z"/><circle pid="1" cx="16" cy="13.5" r="2"/><path pid="2" d="M15.5 13.5h1v13h-1zM8.5 32H0v-8.5h1V31h7.5zM14.27 31h3.462v1H14.27zM32 32h-8.5v-1H31v-7.5h1zM31 14.27h1v3.461h-1zM32 8.5h-1V1h-7.5V0H32zM14.269 0h3.462v1h-3.462zM1 8.5H0V0h8.5v1H1zM0 14.269h1v3.461H0z"/>'
  }
})
